<template>
  <div class="pwd">
    <el-card class="order">
      <div class="top">
        <el-form :inline="true" :model="req" class="demo-form-inline">
          <el-form-item :label="$t('perOrder.orderNumber')">
            <el-input
              v-model="orderCode"
              @change="init()"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('perOrder.productName')">
            <el-input
              v-model="productName"
              @change="init()"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('perOrder.partNo')">
            <el-input
              v-model="partNo"
              @change="initOne()"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('perOrder.orderTime')">
            <el-date-picker
              @change="init()"
              size="mini"
              v-model="time"
              type="daterange"
              :range-separator="$t('perOrder.to')"
              :start-placeholder="$t('perOrder.startDate')"
              :end-placeholder="$t('perOrder.endingDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="success"
              @click="onSubmit"
              size="mini"
              @keyup.enter.native="seachEnter"
              >{{ $t("perOrder.query") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="orderBox">
        <el-radio-group v-model="activeName" @change="init()">
          <el-radio-button label="3">{{
            $t("perOrder.allOrders")
          }}</el-radio-button>
          <el-radio-button label="1">{{
            $t("perOrder.toAudit")
          }}</el-radio-button>
          <el-radio-button label="2">
            {{ $t("perOrder.pass") }}
          </el-radio-button>
        </el-radio-group>
        <div class="box">
          <div class="topBox">
            <el-row>
              <el-col :span="12">
                <strong>{{
                  $t("perOrder.commodityInformation")
                }}</strong></el-col
              >
              <el-col :span="4"
                ><strong>{{ $t("perOrder.money") }}</strong></el-col
              >
              <el-col :span="4"
                ><strong>{{ $t("perOrder.state") }}</strong></el-col
              >
              <el-col :span="4"
                ><strong>{{ $t("perOrder.operation") }}</strong></el-col
              >
            </el-row>
          </div>
          <ul>
            <li v-for="item in list" :key="item.id">
              <div class="liTop">
                {{ $t("perOrder.orderNumber") }}{{ item.orderCode }}
                <span class="time">
                  {{ $t("perOrder.timeOrders") }}{{ item.createTime }}</span
                >
              </div>
              <div class="liBd">
                <el-row>
                  <el-col class="dd-1" :span="11">
                    <div
                      class="clearfix"
                      style="
                        padding: 0.625rem 0;
                        border-bottom: 0.0625rem solid #eee;
                        overflow: hidden;
                      "
                      v-for="item2 in item.orderProductList"
                      :key="item2.id"
                    >
                      <img
                        :src="
                          (item2.productPicture &&
                            item2.productPicture.split(',')[0]) ||
                            ''
                        "
                        v-show="item2.productPicture"
                        alt=""
                      />
                      <div class="name">
                        {{ getText(item2, "productTitle") }}
                        <v-if v-if="item2.partNo != '' && item.partNo != nul1">
                          <br />
                          我司料号：{{ item.partNo }}
                          <br />
                        </v-if>
                      </div>
                      <!-- <span class="red">￥{{ item2.discountAmount }}</span> -->
                      <span class="hui">x{{ item2.productNumber }}</span>
                    </div>
                  </el-col>
                  <el-col class="dd-2" :span="5">
                    <span class="red">
                      {{ $t("perOrder.salesPrice") }}￥{{
                        item.salesAmount || "-"
                      }}
                    </span>
                    <br />
                    <!-- <span class="">
                      {{ $t("perOrder.discountPrice") }}￥{{
                        item.discountAmount || "-"
                      }}
                      </span> -->
                    <br />
                    <span class="hui">
                      {{ $t("perOrder.originalPrice") }}￥{{
                        item.productAmount
                      }}
                    </span>
                  </el-col>
                  <el-col class="dd-3" :span="3">{{
                    item.orderStatusDesc
                  }}</el-col>
                  <el-col class="dd-4" :span="5">
                    <!-- 产品复购添加模块 -->
                    <a
                      class="dd-but dd-but2"
                      style="display: block"
                      target="_blank"
                      @click="toCart(item)"
                    >
                      {{ $t("perOrder.productRepurchase") }}
                    </a>
                    <a
                      @click="toDetails(item)"
                      class="dd-but dd-but1"
                      style="
                        display: block;
                        border: 1px solid #333;
                        background: #fff;
                        color: #333;
                      "
                      >{{ $t("perOrder.theOrderDetails") }}</a
                    >
                    <a
                      class="dd-but dd-but1"
                      style="display: block"
                      target="_blank"
                      v-if="item.orderStatus == '2'"
                      @click="showMessage"
                    >
                      {{ $t("perOrder.priceSheet") }}
                    </a>
                    <a
                      class="dd-but dd-but2"
                      style="display: block"
                      target="_blank"
                      v-if="item.orderStatus == '2'"
                      @click="showMessage"
                    >
                      {{ $t("perOrder.electronicContract") }}
                    </a>
                    <!-- :href="'/c/order/export/liaison/' + item.orderCode" -->
                    <a
                      class="dd-but dd-but3"
                      style="display: block"
                      target="_blank"
                      v-if="item.orderStatus == '2'"
                      @click="showMessage"
                    >
                      {{ $t("perOrder.productionLiaison") }}
                    </a>
                  </el-col>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import Store from "../store";
import moment from "moment";
import { getLang } from "../plugins/common";

export default {
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    if (window.sessionStorage.getItem("daishengpi")) {
      this.activeName = "1";
      window.sessionStorageNaNpxoveItem("daishengpi");
    }
    Store.setPath("2");
    this.init();
  },
  data() {
    return {
      store: Store.state,
      // 选中的哪一个
      activeName: "3",
      value1: "",
      pageSize: 9999,
      pageNumber: 1,
      time: "", //筛选时间
      orderCode: "", //订单号
      productName: "",
      partNo: "",
      // PartNumber: "",//料号
      total: "",
      formInline: {
        user: "",
        region: "",
      },
      // 请求对象
      req: {
        // 产品名称
        name: "",
        createTimeFrom: "", //创建时间起 **********
        createTimeTo: "", //创建时间止 ************
        orderCode: "", //订单编号
        orderCodeLike: "", //订单编号模糊字段  ***************
        orderStatus: "", //订单状态
        orderStatusList: "", //订单状态列表
        pageNo: 1, //第几页
        pageSize: 10, //每页多少数据
      },
      list: [
        {
          createTime: "", //	创建时间	string(date-time)
          discountAmount: 0, //	折扣金额	number
          id: 0, //id		integer(int64)
          orderCode: "", //	订单编号	string
          productAmount: 0, //	产品金额	number
          productConfig: "", //	产品配置	string
          productNumber: 0, //	产品数量	integer(int32)
          productPicture: "", //	产品图片	string
          productTitle: "", //	产品标题	string
          productVideo: "", //	产品视频	string
          productId: "", //	产品ID
          userId: 0, //	用户id
        },
      ],
    };
  },
  methods: {
    getText(parntProp, prop) {
      return getLang(this.$i18n.locale, parntProp, prop);
    },
    seachEnter(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.goSearchProduct(); //搜索按钮的回调
      }
    },
    async init() {
      let params = {
        pageSize: 40,
        pageNo: 1,
      };
      if (this.activeName != "3") {
        params.orderStatus = this.activeName;
      }
      if (this.orderCode) {
        params.orderCodeLike = this.orderCode;
      }
      if (this.productName) {
        params.productName = this.productName;
      }
      if (this.partNo) {
        params.partNo = this.partNo;
      }
      if (this.time[0]) {
        params.createTimeFrom = moment(this.time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (this.time[1]) {
        params.createTimeTo = moment(this.time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let { data: res } = await this.$http.post("/c/order/query", params);
      console.log(params);
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.total = res.data.totalRecords;
      this.list = res.data.records;
    },

    async initOne() {
      let params = {
        pageSize: 40,
        pageNo: 1,
      };
      if (this.partNo) {
        params.partNo = this.partNo;
      }
      let { data: res } = await this.$http.post("/c/order/query1", params);
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.total = res.data.totalRecords;
      this.list = res.data.records;
    },
    showMessage() {
      this.$message("请前往订单管理处导出");
    },
    toDetails(item) {
      this.$router.push({
        path: "/personal/xiang",
        query: {
          productId: item.orderCode,
        },
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    async downloadPdf(type, downloadType, item) {
      let { data: res } = await this.$http.get(
        `/c/order/get/${type}/${item.orderCode}`
      );
      if (res.code != 200 && res.data) {
        return this.$message.error(res.message);
      } else {
        window.location.href = `/c/order/export/${downloadType}/${item.orderCode}`;
      }
    },
    show() {
      console.log(this.value1);
    },
    goXiang(code) {
      this.$router.push("/personal/xiang");
      this.$router.push({
        path: "/personal/xiang",
        query: {
          orderCode: code,
        },
      });
    },

    async toCart(productDatas) {
      // for(let index = 0; productDatas.orderProductList.length >index ; index++){
      //   // let productId = null;
      //   console.log(productDatas)
      // }
      for (
        let index = 0;
        productDatas.orderProductList.length > index;
        index++
      ) {
        // let productTitle = productDatas.orderProductList[index].productTitle
        // console.log(productTitle)
        // console.log(productDatas)
        let { data: res } = await this.$http.put("/c/cart/add", {
          // 产品id
          productId: productDatas.orderProductList[index].productId,
          productNumber: productDatas.orderProductList[index].productNumber,
          productModel: productDatas.orderProductList[index].productModel,
          productPrice: productDatas.orderProductList[index].productAmount,
          salesAmount: productDatas.orderProductList[index].salesAmount,
          productConfig: JSON.parse(
            productDatas.orderProductList[index].productConfig
          ),
          orderCode: productDatas.orderCode,
        });
        if (res.code != 200) {
          return this.$message.error(res.message);
        }
        this.$message.success("复购成功");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pwd {
  width: 60rem;
  height: 46.875rem;
  background-color: #fff;
  .top {
    .el-input {
      width: 10rem !important;
    }
  }
  .box {
    border-left: 0.0313rem solid #ccc;
    border-right: 0.0313rem solid #ccc;
  }
  .topBox {
    height: 3.75rem;
    background-color: #f1f1f1;
    border: 0.0625rem solid #ccc;
    border-left: 0.0313rem solid #ccc;
    border-right: 0.0313rem solid #ccc;
    line-height: 3.125rem;
    padding-left: 1.25rem;
  }
  ul {
    li {
      height: auto;
      margin: 1.25rem 0;
      border-bottom: 0.0313rem solid #ccc;
      .liTop {
        height: 3.125rem;
        background-color: #f1f1f1;
        line-height: 3.125rem;
        padding-left: 1.25rem;
        .time {
          margin-left: 5rem;
        }
      }
      .liBd {
        > div {
          display: flex;
          align-items: center;
        }
        .dd-1 {
          padding: 1.25rem;
          height: auto;
          img {
            width: 6.25rem;
            height: 6.25rem;
            float: left;
            margin-right: 1.25rem;
          }
          .name {
            line-height: 1.875rem;
          }
          .hui {
            margin-left: 0.625rem;
            line-height: 1.875rem;
          }
          border-right: 0.0313rem solid #ccc;
        }
        .dd-2 {
          height: 100%;
          padding: 1.25rem;
          text-align: center;
          line-height: 1.875rem;
        }
        .dd-3 {
          height: 100%;
          padding: 1.25rem;
          text-align: center;
        }
        .dd-4 {
          padding: 1.25rem;
          text-align: center;
          height: 100%;
          .dd-but {
            width: 8.75rem;
            border-radius: 0.3125rem;
            text-align: center;
            height: 1.875rem;
            line-height: 1.875rem;
            margin: 0.625rem auto;
            color: #fff;
          }
          .dd-but1 {
            //   color: rgb(67, 188, 183);
            background-color: rgb(67, 188, 183);
          }
          .dd-but2 {
            background-color: rgb(67, 105, 186);
          }
          .dd-but3 {
            background-color: rgb(253, 172, 0);
          }
        }
      }
    }
  }
}
</style>
